import { create } from 'zustand';
import { BASE_URL } from '../constants';
import { apiFetch } from '../utils/apiFetch';

export const useUserStore = create((set, get) => ({
  user: null,
  imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png',
  isReady: false,
  _userLoading: false,

  setUser: (user) => set({ user }),

  setImageUrl: (imageUrl) => set({ imageUrl }),

  loadUser: async () => {
    const { user, _userLoading } = get();
    if (_userLoading || user) return;

    const token = localStorage.getItem('teacher_authToken') || localStorage.getItem('authToken');
    if (!token) return;

    set({ _userLoading: true });
    try {
      const [res] = await Promise.all([
        apiFetch(BASE_URL + '/users/get-user-object'),
        new Promise((r) => setTimeout(r, 600)),
      ]);
      const data = await res.json();
      localStorage.setItem('userData', JSON.stringify(data));
      set({ user: data });

      if (data.imageFileId) {
        await get().loadImage(data.imageFileId);
      } else {
        set({ isReady: true });
      }
    } catch {
      const stored = localStorage.getItem('userData');
      if (stored) {
        const data = JSON.parse(stored);
        set({ user: data });
        if (data.imageFileId) {
          await get().loadImage(data.imageFileId);
        } else {
          set({ isReady: true });
        }
      } else {
        set({ isReady: true });
      }
    } finally {
      set({ _userLoading: false });
    }
  },

  loadImage: async (imageFileId) => {
    const token = localStorage.getItem('teacher_authToken') || localStorage.getItem('authToken');
    if (!imageFileId || !token) return;
    try {
      const res = await apiFetch(BASE_URL + `/files/file-object/${imageFileId}`);
      const json = await res.json();
      if (json.fileUuidName) {
        const url = BASE_URL + `/files/download/${json.fileUuidName}`;
        await new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = resolve;
          img.src = url;
        });
        set({ imageUrl: url, isReady: true });
      } else {
        set({ isReady: true });
      }
    } catch {
      set({ isReady: true });
    }
  },

  updateImage: (fileUuidName, imageFileId) => {
    set((state) => ({
      imageUrl: BASE_URL + `/files/download/${fileUuidName}`,
      user: state.user ? { ...state.user, imageFileId } : state.user,
    }));
    const stored = localStorage.getItem('userData');
    if (stored) {
      const updated = { ...JSON.parse(stored), imageFileId };
      localStorage.setItem('userData', JSON.stringify(updated));
    }
  },
}));
